const updColeccSI_ID = (creaColecc, movColecc, createColecc, editColecc) => {
  let numDocCRUD = 0
  let totDocCRUD = movColecc.length + 1
  let argsCrud = []
  let crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(editColecc)
  }

  argsCrud[numDocCRUD] = creaColecc[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
  argsCrud[numDocCRUD]['ctrl_id'] = 'SI_ID'
  crudColecc[numDocCRUD] = createColecc

  numDocCRUD += 1

  movColecc.forEach((elemento1, ii) => {
    argsCrud[numDocCRUD] = elemento1
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

    numDocCRUD += 1
  })

  let updColecc ={crudColecc, argsCrud, totDocCRUD}
  return(updColecc)
}

export default updColeccSI_ID
